import { type DbVariant } from "@/hooks/useProducts";

type Props = {
  variants: DbVariant[];
  selected: Record<string, string>;
  onSelect: (variantName: string, option: string) => void;
  isOptionAvailable?: (variantName: string, option: string) => boolean;
};

export default function VariantPicker({ variants, selected, onSelect, isOptionAvailable }: Props) {
  if (variants.length === 0) return null;
  return (
    <div className="space-y-5">
      {variants.map((v) => (
        <div key={v.id}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs tracking-widest uppercase text-foreground-600">
              {v.name}
            </span>
            <span className="text-sm font-medium text-foreground-950">
              {selected[v.name] ?? "Pick one"}
            </span>
          </div>
          <div className="flex flex-wrap gap-2">
            {v.options.map((opt) => {
              const active = selected[v.name] === opt;
              const available = isOptionAvailable ? isOptionAvailable(v.name, opt) : true;
              return (
                <button
                  key={opt}
                  type="button"
                  onClick={() => onSelect(v.name, opt)}
                  disabled={!available}
                  className={`px-4 h-10 rounded-full border text-sm transition-colors whitespace-nowrap cursor-pointer ${
                    active
                      ? "bg-foreground-950 text-background-50 border-foreground-950"
                      : available
                        ? "bg-background-50 text-foreground-900 border-background-300 hover:border-foreground-400"
                        : "bg-background-50 text-foreground-400 border-background-200 line-through cursor-not-allowed"
                  }`}
                >
                  {opt}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}